// extracted by mini-css-extract-plugin
module.exports = {"RecipeCreator":"RecipeCreator_RecipeCreator__2z20o"};